<template>
  <div class="pi-skeleton-container">
    <div class="pi-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
      <Skeleton height="18px" width="216px" borderRadius="4px" />
    </div>
    <div class="pi-skeleton-container-main">
      <Skeleton
        v-for="i in 4"
        :key="i"
        :svgSrc="PdpCartSvg"
        height="64px"
        width="64px"
        borderRadius="8px"
      />
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
import PdpCartSvg from '@/assets/images/skeleton/pdp-cart.svg';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.pi-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;
  &-header,
  &-main {
    display: flex;
    align-self: stretch;
  }

  &-header {
    padding: 24px 24px 16px 24px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    padding: 24px;
    align-items: flex-start;
    gap: 16px;
  }
}
</style>
